import React, {useEffect, useState} from 'react';
import "./forIssuers.css"
import Header from "../components/Header";
import Footer from "../components/Footer";
import main_block_bg from "./images/main_page_bg.svg";
import left_top_banner_image from "./images/left_top_banner_image.png";
import left_bottom_banner_image from "./images/left_bottom_banner_image.png";
import right_top_banner_image from "./images/right_top_banner_image.png";
import right_bottom_banner_image from "./images/right_bottom_banner_image.png";
import default_img from "../UnduraCore/images/default_img.svg";
import issuer_icon1 from "./images/issuer_icon1.svg";
import issuer_icon2 from "./images/issuer_icon2.svg";
import issuer_icon3 from "./images/issuer_icon3.svg";
import issuer_icon4 from "./images/issuer_icon4.svg";
import core_essentials1 from "./images/core_essentials1.svg";
import core_essentials2 from "./images/core_essentials2.svg";
import core_essentials3 from "./images/core_essentials3.svg";
import FaqItem from "../MainPage/components/FaqItem";
import circles_bg from "../ForDonors/images/circles.svg";
import stay_informed_bg_top from "../UnduraCore/images/stay_informed_bg_top.svg";
import InputContainer from "../UnduraCore/components/InputContainer";
import mail_icon from "../UnduraCore/images/mail_icon.svg";
import send_plane_icon from "../UnduraCore/images/send_plane.svg";
import stay_informed_bg_bottom from "../UnduraCore/images/stay_informed_bottom_bg.svg";
import inputNameIcon from "../UnduraCore/images/userNameIcon.svg";
import inputPencilIcon from "../UnduraCore/images/pencilIcon.svg";
import white_logo from "../UnduraCore/images/white_logo.svg";
import undura_logo_grad from "./images/undura_core_grad_image.svg";
import issuer_instrument_framework from "./images/issuers_instrument_framework.png";
import issuer_secondary_market from "./images/issuers)instrument_framework.png";
import issuer_pricing_factor from "./images/pricing_factor_new.png";

import { motion } from "framer-motion";
import stat_blue_gal from "../Platforms/images/stat_blue_gal.svg";
import {Helmet} from "react-helmet";
import {Link} from "react-scroll";
import axios from "axios";
import warning_triangle from "../UnduraCore/images/warning_triangle.svg";
import CoreWarning from "../UnduraCore/components/CoreWarning";



const ForIssuers = () => {

    const [contactEmail, setContactEmail] = useState("")
    const [contactFullName, setContactFullName] = useState("")
    const [contactMessage, setContactMessage] = useState("")
    const [subscribeValue, setSubscribeValue] = useState("")

    let sendApiContact = () => {
        axios.post("https://api.undura.com/api/v1/contact", {
            full_name: contactFullName,
            email: contactEmail,
            message: contactMessage,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }
    let sendApiSubscribe = () => {
        axios.post("https://api.undura.com/api/v1/newsletter/subscribe", {
            email: subscribeValue,
            honeypot: ""
        }).then(r => console.log(r)).catch((er) => console.error(er))
    }

    useEffect(() => {
        const hash = window.location.hash;
        if (!hash) return;

        const el = document.querySelector(hash);
        if (!el) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                window.history.replaceState(null, "", window.location.pathname);
                observer.disconnect();
            }
        }, { threshold: 0.5 });

        observer.observe(el);

        setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
        }, 300);

    }, []);

    const [isExpandedLabel, setIsExpandedLabel] = useState(false);

    const faq_items = [{
        question: "How do I create my platform?",
        answer: "Your platform is deployed as a white-label environment under your own brand. Setup includes domain configuration, roles, and instrument selection within ECSPR scope."
    }, {
        question: "What are the fees?",
        answer: "Pricing depends on setup complexity, instrument scope, transaction volume, and third-party costs (KYC/EMI). All external fees are passed through transparently."
    }, {
        question: "Is this safe and compliant?",
        answer: "Core operates under ECSPR requirements: conflict-of-interest controls, KYB/KYC/AML verification, escrow via licensed EMIs, immutable audit records, and GDPR-aligned data handling."
    }, {
        question: "Can I use my own domain and branding?",
        answer: "Yes. Each issuer operates a fully branded environment with its own domain, identity, and investor interface, while infrastructure and compliance remain centralized."
    }, {
        question: "How long does onboarding take?",
        answer: "Time depends on KYB/UBO verification, conflict-of-interest checks, and offer preparation. Typical onboarding involves pre-assessment, verification, platform setup, and compliance review before launch."
    }]






    const [isExpanded1, setIsExpanded1] = useState(false);
    const toggleDescription1 = () => {
        setIsExpanded1(!isExpanded1);
    };
    const descClasses1 = `pricing_factors_desc ${isExpanded1 ? 'expanded' : ''}`;


    const [isFocusedTextarea, setIsFocusedTextarea] = useState(false);

    const focusedTextArea = `textarea_bg ${isFocusedTextarea ? 'focused_textarea' : ''}`;


    const fadeUpItem = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
    };

    const staggerContainer = {
        hidden: { opacity: 1 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15
            }
        }
    };

    const imageReveal = {
        hidden: { opacity: 0, y: 20, scale: 0.95 },
        visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, ease: "easeOut" } }
    };

    const hoverScale = { whileHover: { scale: 1.03 }, transition: { type: "spring", stiffness: 250 } };

    const sectionViewport = { initial: "hidden", whileInView: "visible", viewport: { once: true, amount: 0.3 } };



    const pointVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: { delay: i * 0.15, duration: 0.6, ease: "easeOut" }
        })
    };
    const fadeNumeric = {
        initial: "hidden",
        whileInView: "visible",
        viewport: { once: true },
        variants: pointVariants
    };

    const fadeUp = { initial: { opacity: 0, y: 40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeDown = { initial: { opacity: 0, y: -40 }, whileInView: { opacity: 1, y: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeLeft = { initial: { opacity: 0, x: -50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const fadeRight = { initial: { opacity: 0, x: 50 }, whileInView: { opacity: 1, x: 0 }, viewport: {once: true, amount: 0.3}, transition: { duration: 0.8, ease:"easeOut"} };
    const toggleDescriptionLabel = () => {
        if (isExpandedLabel) {
            setIsExpandedLabel(false);
            setTimeout(() => setClamped(true), 600); // чтобы анимация завершилась перед клэмпингом
        } else {
            setClamped(false);
            setIsExpandedLabel(true);
        }
    };
    const [isExpanded, setIsExpanded] = useState(false);
    const [clamped, setClamped] = useState(true);

    const toggleDescription = () => {
        if (isExpanded) {
            setIsExpanded(false);
            setTimeout(() => setClamped(true), 600); // чтобы анимация завершилась перед клэмпингом
        } else {
            setClamped(false);
            setIsExpanded(true);
        }
    };

    const descClasses = `white_label_desc ${isExpanded ? "expanded" : ""} ${clamped ? "clamped" : ""}`;


    const statVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
    };

    const hoverButton = {
        whileHover: {
            scale: 1.05,
            transition: { type: "spring", stiffness: 300 }
        }
    };



    const buttonAnimate = {
        initial:fadeUp.initial,
        whileInView:fadeUp.whileInView,
        viewport:fadeUp.viewport,
        transition:fadeUp.transition,
        whileHover:hoverButton.whileHover
    }



    return (
        <div className="for_issuers_page">
            <CoreWarning/>
            <Helmet>
                <link rel="preload" as="image" href={right_top_banner_image} />
                <link rel="preload" as="image" href={left_bottom_banner_image} />
                <link rel="preload" as="image" href={right_bottom_banner_image} />
                <link rel="preload" as="image" href={left_top_banner_image} />
            </Helmet>
            <motion.img src={main_block_bg} alt="" className="main_block_bg" {...fadeUp}/>

            <Header mode="core"/>

            <div className="for_issuers_banners">
                <img src={left_top_banner_image} alt="" className="left_top_banner_image" />
                <img src={left_bottom_banner_image} alt="" className="left_bottom_banner_image" />
                <div className="for_issuers_banners_text">
                    <motion.div className="sticky_disclaimer" {...fadeUp}>
                        <div className="circle"></div>
                        For Issuers
                    </motion.div>

                    <motion.div className="main_text_banners" {...fadeLeft}>
                        Operate a compliant investment platform under your own brand
                    </motion.div>

                    <motion.div className="for_issuers_banners_desc" {...fadeRight}>
                        Core v1.0 under ECSPR and aligned with MiFID principles. A neutral infrastructure for regulated
                        capital raising and securities issuance.
                    </motion.div>

                    <motion.div className="for_issuers_main_buttons" >
                        <motion.a className="sys_overview" href = "/" {...buttonAnimate} custom={0} {...fadeNumeric}>
                            Live Analogue (Lite)
                        </motion.a>
                        <a href = "#issuers_overview">
                        <motion.div className="issuers_overview" {...buttonAnimate} custom={1} {...fadeNumeric}>
                            Issuer Journey
                        </motion.div>
                        </a>
                    </motion.div>
                </div>
                <img src={right_top_banner_image} alt="" className="right_top_banner_image" />
                <img src={right_bottom_banner_image} alt="" className="right_bottom_banner_image" />

            </div>


            <div className="white_label" id = "whiteLabel">

                <motion.div className="white_label_info" {...fadeLeft}>
                    <motion.div
                        className="white_label_name"
                        initial={{ opacity: 0, x: -30 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.5 }}

                    >
                        White-Label <span>Model</span>
                    </motion.div>


                    <motion.div
                        className={descClasses}
                        onClick={toggleDescription}
                        layout
                    >
                        Undura Core provides a neutral infrastructure layer that enables issuers to operate branded
                        investment platforms with configurable instruments and processes.
                        The framework is designed for adaptation to specific structures within a regulated environment,
                        allowing new models to be tested without breaching ECSPR or MiFID boundaries.

                        Key characteristics:<br/>
                        – Branded interface under the issuer’s identity<br/>
                        – Neutral operational and compliance layer<br/>
                        – Configurable instruments within ECSPR scope<br/>
                        – Clear separation of roles to avoid conflicts of interest (Art. 8 ECSPR)<br/>
                        – Full auditability and standardized reporting<br/>
                    </motion.div>
                    <motion.div className="read_more_button" onClick={toggleDescription} variants={fadeUpItem} >
                        {isExpanded ? "Read less:" : "Read more" }
                    </motion.div>

                    <motion.a href = "/" className="issuer_article_button" {...buttonAnimate}>
                        View White-Label Lite Analogue
                    </motion.a>


                </motion.div>


                <motion.div className="white_label_image" {...fadeRight}>
                    <img src={undura_logo_grad} alt=""/>
                </motion.div>
            </div>

            <motion.div className="main_text" {...fadeUp}>
                <span>Issuer</span> Journey
            </motion.div>
            <a id = "issuers_overview"></a>
            <motion.div className="issuer_journey_four_blocks" >
                {[{
                    icon: issuer_icon1,
                    title: "Pre-Assessment",
                    desc: "Initial eligibility review, basic information, project outline, regulatory fit."
                },{
                    icon: issuer_icon2,
                    title: "KYB & UBO verification",
                    desc: "Verification of company identity, ownership, directors, and statutory records (KYB/UBO/KYC)."
                },{
                    icon: issuer_icon3,
                    title: "Conflict of Interest Check",
                    desc: "Assessment of structural and operational independence to meet ECSPR conflict-management requirements."
                },{
                    icon: issuer_icon4,
                    title: "Platform Setup",
                    desc: "Branding, domain configuration, role management, access controls."
                }].map((b, i) => (
                    <motion.div className="issuer_journey_block" key={i} {...fadeNumeric} custom={i}>
                        <div className="issuer_icon_number">
                            <img src={b.icon} alt="" />
                            <div className="issuer_number">0{ i+1 }</div>
                        </div>
                        <div className="issuers_block_desc">{b.title}</div>
                        <div className="core_essentials_desc">{b.desc}</div>
                    </motion.div>
                ))}
            </motion.div>

            <motion.div className="issuer_journey_five_blocks">
                {[{
                    icon: issuer_icon1,
                    title: "Offer Structuring",
                    desc: "Selection of instrument (loan/bond/equity), preparation of key terms, KIIS draft."
                },{
                    icon: issuer_icon2,
                    title: "Compliance Review",
                    desc: "Fair, clear, and not misleading assessment of the offer; validation of disclosures."
                },{
                    icon: issuer_icon3,
                    title: "Payments & Escrow",
                    desc: "Setup of escrow accounts, payment routing configuration, integration with regulated EMI/PI provider."
                },{
                    icon: issuer_icon4,
                    title: "Launch & Monitoring",
                    desc: "Opening the offer to investors, live monitoring of subscriptions, communication with verified investors."
                },{
                    icon: issuer_icon4,
                    title: "Settlement & Reporting",
                    desc: "Post-campaign settlement, payouts to issuer, investor allocation, regulatory reporting (ECSPR outcomes, audit logs)."
                }].map((b, i) => (
                    <motion.div className="issuer_journey_block" key={i} {...fadeNumeric} custom={i}>
                        <div className="issuer_icon_number">
                            <img src={b.icon} alt=""/>
                            <div className="issuer_number">0{5 + i}</div>
                        </div>
                        <div className="issuers_block_desc">{b.title}</div>
                        <div className="core_essentials_desc">{b.desc}</div>
                    </motion.div>
                ))}
            </motion.div>


            <motion.div className="white_label" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="white_label_info" {...fadeLeft}>
                    <div className="white_label_name" >Instruments & Frameworks</div>
                    <div className="white_label_desc" >
                        Undura Core supports regulated investment instruments within the ECSPR framework. Each instrument is implemented with standardized disclosures, independent compliance checks, investor protections, and verified settlement via licensed EMIs.
                    </div>

                    <div className="mini_article_desc">
                        Additional regimes (e.g., MiFID II) may be supported subject to licensing and regulatory conditions.
                    </div>
                </motion.div>

                <motion.div className="white_label_image" {...fadeRight}>
                    <img src={issuer_instrument_framework} alt=""/>
                </motion.div>
            </motion.div>


            <motion.div className="main_text" {...fadeUp}>
                Undura Core Essentials
            </motion.div>

            <motion.div className="core_essentials_three_blocks">
                <motion.div className="core_essentials_block" {...fadeNumeric} custom={0}>
                    <div className="core_essentials_number">
                        <img src={core_essentials1} alt=""/>
                        "Undura does not hold client money."
                    </div>
                    <div className="core_essentials_name">Payments & Escrow</div>
                    <div className="core_essentials_desc">Investor funds are processed exclusively through licensed EMIs; segregated client accounts ensure regulatory separation; settlement operations follow automated, audit-ready procedures.</div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={1}>
                    <div className="core_essentials_number"><img src={core_essentials2} alt=""/></div>
                    <div className="core_essentials_name">Data & Identity</div>
                    <div className="core_essentials_desc">Tenant-isolated data architecture with verified Undura ID for participation. GDPR-aligned retention, immutable audit records, and fine-grained access controls.</div>
                </motion.div>

                <motion.div className="core_essentials_block" {...fadeNumeric} custom={2}>
                    <div className="core_essentials_number"><img src={core_essentials3} alt=""/></div>
                    <div className="core_essentials_name">Integrations & API</div>
                    <div className="core_essentials_desc">Standardized interfaces for controlled interoperability and regulatory reporting, preserving tenant isolation and alignment with ECSPR and MiFID data requirements.</div>
                </motion.div>
            </motion.div>

            <motion.div className="secondary_market_block">
                <motion.div className="secondary_market_info" {...fadeLeft}>
                    <div className="secondary_market_name" >Secondary Market <span>(Planned)</span></div>
                    <div className="white_label_desc">
                        Undura Core includes a planned secondary-market layer designed to support compliant cross-platform transfers within the Undura Network.
                        The module will be activated only after obtaining the MiFID II license and meeting all related regulatory conditions.
                    </div>
                </motion.div>

                <motion.div className="white_label_image" {...fadeRight}>
                    <img src={issuer_secondary_market} alt=""/>
                </motion.div>
            </motion.div>


            <motion.div className="pricing_factors" >
                <motion.div className="pricing_factors_image" {...fadeLeft}>
                    <img src={issuer_pricing_factor} alt=""/>
                </motion.div>

                <motion.div className="pricing_factors_info" {...fadeRight} >
                    <div className="pricing_factors_name">Pricing Factors & SLA</div>
                    <div className="pricing_factors_desc expanded" id = "pricing-factors">
                        Pricing depends on several operational and regulatory variables, including platform setup complexity (branding, domain, integrations), instrument scope, transaction volume, support tier, and jurisdictional coverage.
                        Third-party costs such as KYC verification and EMI/PI payment processing are passed through transparently.
                        SLA targets include uptime, operational continuity, and response times defined for each service tier.
                    </div>
                </motion.div>
            </motion.div>


            <motion.div className="main_text" {...fadeLeft}>
                Questions you might have
            </motion.div>

            <motion.div className="faq_full" {...sectionViewport} variants={staggerContainer}>
                <div className="bg_circles"><motion.img
                    alt=""
                    src={circles_bg}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                /></div>
                <motion.div className="faq_main" variants={staggerContainer}>
                    {faq_items.map((e, idx) => (
                        <motion.div key={idx} variants={fadeUpItem}>
                            <FaqItem answer={e.answer} question={e.question}/>
                        </motion.div>
                    ))}
                </motion.div>

            </motion.div>


            <motion.div className="stay_informed_block" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="stay_informed_block_info" variants={fadeUpItem}>
                    <motion.img src={stay_informed_bg_top} alt="" className="stay_informed_bg_top" variants={imageReveal}/>
                    <motion.div className="stay_informed_content" variants={fadeUpItem}>
                        <motion.div className="powered_by" variants={fadeUpItem}>
                            <div className="circle"></div>
                            Powered by Undura Core
                        </motion.div>
                        <motion.div className="stay_informed_main" variants={fadeUpItem}>Stay informed about Undura Core updates</motion.div>
                        <motion.div className="stay_informed_desc" variants={fadeUpItem}>
                            Subscribe to receive early access to technical releases, integration notes, and
                            documentation updates.
                            <br/><br/>
                            Information is shared periodically and limited to infrastructure and regulatory
                            developments.
                        </motion.div>
                        <motion.div variants={fadeUpItem} className = "mob_100">
                            <InputContainer inputPlaceholder="your.email@organization.com" inputIcon={mail_icon}
                                            inputType="email" value={subscribeValue} onChange={(el) => {
                                setSubscribeValue(el.target.value)
                                            }}>
                                <div className="send_button" onClick={() => {
                                    sendApiSubscribe()
                                }}>
                                    <img src={send_plane_icon} alt=""/>
                                </div>
                            </InputContainer>
                        </motion.div>
                    </motion.div>
                    <motion.img src={stay_informed_bg_bottom} alt="" className="stay_informed_bg_bottom" variants={imageReveal}/>
                </motion.div>
            </motion.div>

            {/* Get in touch */}
            <motion.div className="get_in_touch_full_block" {...sectionViewport} variants={staggerContainer}>
                <motion.div className="get_in_touch_block" variants={staggerContainer}>
                    <motion.div className="get_in_touch_message_block" variants={fadeUpItem}>
                        <motion.div className="get_in_touch_name" variants={fadeUpItem}>
                            Get in Touch
                        </motion.div>
                        <form className="get_in_touch_form">
                            <div className="input_name">Full Name<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="James Brown" inputIcon={inputNameIcon} inputType="text" value={contactFullName} onChange={(e) => {
                                    setContactFullName(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">E-mail<span>*</span></div>
                            <motion.div variants={fadeUpItem}>
                                <InputContainer inputPlaceholder="hello@undura.com" inputIcon={mail_icon} inputType="text" value={contactEmail} onChange={(e) => {
                                    setContactEmail(e.target.value)
                                }}/>
                            </motion.div>

                            <div className="input_name">Your message<span>*</span></div>
                            <div className="textarea_container">
                                <motion.div className={focusedTextArea} variants={fadeUpItem}>
                                    <img src={inputPencilIcon} alt=""/>
                                    Type here
                                </motion.div>
                                <textarea className="type_here_textarea" onFocus={() => {
                                    setIsFocusedTextarea(true)
                                }} onBlur={(e) => {
                                    if (e.target.value.length === 0) {
                                        setIsFocusedTextarea(false)
                                    }
                                }} value={contactMessage} onChange={(e) => {
                                    setContactMessage(e.target.value)
                                }}/>
                            </div>
                            <motion.button className="get_in_touch_form_submit" type="submit"
                                           onClick={(e) => {
                                               e.preventDefault()
                                               sendApiContact()
                                           }} variants={fadeUpItem} {...hoverScale}>
                                Submit Inquiry
                            </motion.button>
                        </form>
                    </motion.div>

                    <motion.div className="about_undura_get_in_touch" variants={fadeUpItem}>
                        <img src={white_logo} alt=""/>

                        <div className="about_undura_get_in_touch_main_text">
                            Reach out to discuss partnership opportunities, platform integration,
                            or other collaboration formats within the Undura ecosystem.
                        </div>
                        <div className="about_undura_get_in_touch_desc">
                            Messages are handled directly by the Core team.
                        </div>
                    </motion.div>
                </motion.div>
            </motion.div>

            <Footer/>
        </div>
    );
};

export default ForIssuers;
